import {
  AccidentAtlasChartConfig,
  isCartesianChartConfig,
  isPieChartConfig,
} from '../types/api'

export function prepareChartData(
  chartConfig?: AccidentAtlasChartConfig | null
): AccidentAtlasChartConfig | undefined {
  if (!chartConfig) return undefined

  if (isCartesianChartConfig(chartConfig)) {
    if (!chartConfig.xAxis?.categories?.length || !chartConfig.series?.length) {
      return undefined
    }

    if (!chartConfig.series.some((series) => series.data?.length)) {
      return undefined
    }

    return chartConfig
  }

  if (isPieChartConfig(chartConfig)) {
    if (!chartConfig.labels?.length || !chartConfig.datasets?.length) {
      return undefined
    }

    if (!chartConfig.datasets.some((dataset) => dataset.data?.length)) {
      return undefined
    }

    return chartConfig
  }

  return undefined
}
